import { useEffect, useState } from "react";

import { Link } from "components/elements";
import { PageContent, PageHeader, Section } from "components/layout";

import { SchedulesInfo } from "./components/SchedulesInfo";
import { ScheduleTable } from "./components/SchedulesTable";
import { SnapshotSchedule } from "./components/SnapshotSchedule";
import { SERVICES, TEXTS } from "./constants";
import { MINUTE_MS } from "./utils";

export function Schedules() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), MINUTE_MS);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <>
      <PageHeader>{TEXTS.SCHEDULES.HEADER}</PageHeader>
      <PageContent>
        <Section>
          <SchedulesInfo now={now} />
        </Section>
        <Section header={TEXTS.SCHEDULES.SNAPSHOT_SECTION}>
          <SnapshotSchedule now={now} />
        </Section>
        <Section>
          {SERVICES.map((service) => (
            <Section key={service.title} header={service.title}>
              {service.calendarUrl && (
                <Link href={service.calendarUrl} target="_blank">
                  {TEXTS.SCHEDULES.VIEW_FULL_CALENDAR}
                </Link>
              )}
              <ScheduleTable now={now} rows={service.stageSchedules} />
            </Section>
          ))}
        </Section>
      </PageContent>
    </>
  );
}
